import { CityConfig } from "./types";

export const CITIES: Record<string, CityConfig> = {
  // --- New Zealand ---
  "auckland-nz": {
    slug: "auckland-nz",
    name: "Auckland",
    country: "New Zealand",
    center: { lat: -36.8485, lng: 174.7633 },
    zoom: 13,
    dbName: "Auckland",
    timezone: "Pacific/Auckland",
  },
  "wellington-nz": {
    slug: "wellington-nz",
    name: "Wellington",
    country: "New Zealand",
    center: { lat: -41.2924, lng: 174.7787 },
    zoom: 13,
    dbName: "Wellington",
    timezone: "Pacific/Auckland",
  },
  "christchurch-nz": {
    slug: "christchurch-nz",
    name: "Christchurch",
    country: "New Zealand",
    center: { lat: -43.5321, lng: 172.6362 },
    zoom: 13,
    dbName: "Christchurch",
    timezone: "Pacific/Auckland",
  },
  "hamilton-nz": {
    slug: "hamilton-nz",
    name: "Hamilton",
    country: "New Zealand",
    center: { lat: -37.7870, lng: 175.2793 },
    zoom: 13,
    dbName: "Hamilton",
    timezone: "Pacific/Auckland",
  },
  "nelson-nz": {
    slug: "nelson-nz",
    name: "Nelson",
    country: "New Zealand",
    center: { lat: -41.2706, lng: 173.284 },
    zoom: 13,
    dbName: "Nelson",
    timezone: "Pacific/Auckland",
  },
  "dunedin-nz": {
    slug: "dunedin-nz",
    name: "Dunedin",
    country: "New Zealand",
    center: { lat: -45.8788, lng: 170.5028 },
    zoom: 13,
    dbName: "Dunedin",
    timezone: "Pacific/Auckland",
  },

  // --- United States ---
  "new-york-ny": {
    slug: "new-york-ny",
    name: "New York",
    country: "United States",
    center: { lat: 40.7128, lng: -74.0060 },
    zoom: 12,
    dbName: "New York",
    timezone: "America/New_York",
  },
  "los-angeles-ca": {
    slug: "los-angeles-ca",
    name: "Los Angeles",
    country: "United States",
    center: { lat: 34.0522, lng: -118.2437 },
    zoom: 11,
    dbName: "Los Angeles",
    timezone: "America/Los_Angeles",
  },
  "nashville-tn": {
    slug: "nashville-tn",
    name: "Nashville",
    country: "United States",
    center: { lat: 36.1627, lng: -86.7816 },
    zoom: 12,
    dbName: "Nashville",
    timezone: "America/Chicago",
  },
  "austin-tx": {
    slug: "austin-tx",
    name: "Austin",
    country: "United States",
    center: { lat: 30.2672, lng: -97.7431 },
    zoom: 12,
    dbName: "Austin",
    timezone: "America/Chicago",
  },
  "new-orleans-la": {
    slug: "new-orleans-la",
    name: "New Orleans",
    country: "United States",
    center: { lat: 29.9511, lng: -90.0715 },
    zoom: 12,
    dbName: "New Orleans",
    timezone: "America/Chicago",
  },
  "chicago-il": {
    slug: "chicago-il",
    name: "Chicago",
    country: "United States",
    center: { lat: 41.8781, lng: -87.6298 },
    zoom: 12,
    dbName: "Chicago",
    timezone: "America/Chicago",
  },
  "atlanta-ga": {
    slug: "atlanta-ga",
    name: "Atlanta",
    country: "United States",
    center: { lat: 33.7490, lng: -84.3880 },
    zoom: 12,
    dbName: "Atlanta",
    timezone: "America/New_York",
  },
  "seattle-wa": {
    slug: "seattle-wa",
    name: "Seattle",
    country: "United States",
    center: { lat: 47.6062, lng: -122.3321 },
    zoom: 12,
    dbName: "Seattle",
    timezone: "America/Los_Angeles",
  },
  "san-francisco-ca": {
    slug: "san-francisco-ca",
    name: "San Francisco",
    country: "United States",
    center: { lat: 37.7749, lng: -122.4194 },
    zoom: 12,
    dbName: "San Francisco",
    timezone: "America/Los_Angeles",
  },
  "detroit-mi": {
    slug: "detroit-mi",
    name: "Detroit",
    country: "United States",
    center: { lat: 42.3314, lng: -83.0458 },
    zoom: 12,
    dbName: "Detroit",
    timezone: "America/Detroit",
  },
  "memphis-tn": {
    slug: "memphis-tn",
    name: "Memphis",
    country: "United States",
    center: { lat: 35.1495, lng: -90.0490 },
    zoom: 12,
    dbName: "Memphis",
    timezone: "America/Chicago",
  },
  "miami-fl": {
    slug: "miami-fl",
    name: "Miami",
    country: "United States",
    center: { lat: 25.7617, lng: -80.1918 },
    zoom: 12,
    dbName: "Miami",
    timezone: "America/New_York",
  },
  "philadelphia-pa": {
    slug: "philadelphia-pa",
    name: "Philadelphia",
    country: "United States",
    center: { lat: 39.9526, lng: -75.1652 },
    zoom: 12,
    dbName: "Philadelphia",
    timezone: "America/New_York",
  },
  "boston-ma": {
    slug: "boston-ma",
    name: "Boston",
    country: "United States",
    center: { lat: 42.3601, lng: -71.0589 },
    zoom: 12,
    dbName: "Boston",
    timezone: "America/New_York",
  },
  "minneapolis-mn": {
    slug: "minneapolis-mn",
    name: "Minneapolis",
    country: "United States",
    center: { lat: 44.9778, lng: -93.2650 },
    zoom: 12,
    dbName: "Minneapolis",
    timezone: "America/Chicago",
  },
  "las-vegas-nv": {
    slug: "las-vegas-nv",
    name: "Las Vegas",
    country: "United States",
    center: { lat: 36.1699, lng: -115.1398 },
    zoom: 12,
    dbName: "Las Vegas",
    timezone: "America/Los_Angeles",
  },
  "denver-co": {
    slug: "denver-co",
    name: "Denver",
    country: "United States",
    center: { lat: 39.7392, lng: -104.9903 },
    zoom: 12,
    dbName: "Denver",
    timezone: "America/Denver",
  },
  "portland-or": {
    slug: "portland-or",
    name: "Portland",
    country: "United States",
    center: { lat: 45.5152, lng: -122.6784 },
    zoom: 12,
    dbName: "Portland",
    timezone: "America/Los_Angeles",
  },
  "washington-dc": {
    slug: "washington-dc",
    name: "Washington, D.C.",
    country: "United States",
    center: { lat: 38.9072, lng: -77.0369 },
    zoom: 12,
    dbName: "Washington",
    timezone: "America/New_York",
  },
  "houston-tx": {
    slug: "houston-tx",
    name: "Houston",
    country: "United States",
    center: { lat: 29.7604, lng: -95.3698 },
    zoom: 11,
    dbName: "Houston",
    timezone: "America/Chicago",
  },
  "dallas-tx": {
    slug: "dallas-tx",
    name: "Dallas",
    country: "United States",
    center: { lat: 32.7767, lng: -96.7970 },
    zoom: 11,
    dbName: "Dallas",
    timezone: "America/Chicago",
  },
  "phoenix-az": {
    slug: "phoenix-az",
    name: "Phoenix",
    country: "United States",
    center: { lat: 33.4484, lng: -112.0740 },
    zoom: 11,
    dbName: "Phoenix",
    timezone: "America/Phoenix",
  },
  "san-diego-ca": {
    slug: "san-diego-ca",
    name: "San Diego",
    country: "United States",
    center: { lat: 32.7157, lng: -117.1611 },
    zoom: 12,
    dbName: "San Diego",
    timezone: "America/Los_Angeles",
  },
  "st-louis-mo": {
    slug: "st-louis-mo",
    name: "St. Louis",
    country: "United States",
    center: { lat: 38.6270, lng: -90.1994 },
    zoom: 12,
    dbName: "St. Louis",
    timezone: "America/Chicago",
  },
  "kansas-city-mo": {
    slug: "kansas-city-mo",
    name: "Kansas City",
    country: "United States",
    center: { lat: 39.0997, lng: -94.5786 },
    zoom: 12,
    dbName: "Kansas City",
    timezone: "America/Chicago",
  },
  "albany-ny": {
    slug: "albany-ny",
    name: "Albany",
    country: "United States",
    center: { lat: 42.6526, lng: -73.7562 },
    zoom: 12,
    dbName: "Albany",
    timezone: "America/New_York",
  },
  "woodstock-ny": {
    slug: "woodstock-ny",
    name: "Woodstock",
    country: "United States",
    center: { lat: 42.0409, lng: -74.1182 },
    zoom: 14,
    dbName: "Woodstock",
    timezone: "America/New_York",
  },
  "saratoga-springs-ny": {
    slug: "saratoga-springs-ny",
    name: "Saratoga Springs",
    country: "United States",
    center: { lat: 43.0831, lng: -73.7846 },
    zoom: 13,
    dbName: "Saratoga Springs",
    timezone: "America/New_York",
  },
  "catskill-ny": {
    slug: "catskill-ny",
    name: "Catskill",
    country: "United States",
    center: { lat: 42.2170, lng: -73.8615 },
    zoom: 14,
    dbName: "Catskill",
    timezone: "America/New_York",
  },
  "chatham-ny": {
    slug: "chatham-ny",
    name: "Chatham",
    country: "United States",
    center: { lat: 42.3656, lng: -73.5951 },
    zoom: 14,
    dbName: "Chatham",
    timezone: "America/New_York",
  },
  "rochester-ny": {
    slug: "rochester-ny",
    name: "Rochester",
    country: "United States",
    center: { lat: 43.1566, lng: -77.6088 },
    zoom: 13,
    dbName: "Rochester",
    timezone: "America/New_York",
  },
  "hudson-ny": {
    slug: "hudson-ny",
    name: "Hudson",
    country: "United States",
    center: { lat: 42.2526, lng: -73.7910 },
    zoom: 14,
    dbName: "Hudson",
    timezone: "America/New_York",
  },

  // --- Kentucky ---
  "lexington-ky": {
    slug: "lexington-ky",
    name: "Lexington",
    country: "United States",
    center: { lat: 38.0406, lng: -84.5037 },
    zoom: 13,
    dbName: "Lexington",
    timezone: "America/New_York",
  },

  // --- United Kingdom ---
  "london-uk": {
    slug: "london-uk",
    name: "London",
    country: "United Kingdom",
    center: { lat: 51.5074, lng: -0.1278 },
    zoom: 12,
    dbName: "London",
    timezone: "Europe/London",
  },
  "manchester-uk": {
    slug: "manchester-uk",
    name: "Manchester",
    country: "United Kingdom",
    center: { lat: 53.4808, lng: -2.2426 },
    zoom: 13,
    dbName: "Manchester",
    timezone: "Europe/London",
  },
  "liverpool-uk": {
    slug: "liverpool-uk",
    name: "Liverpool",
    country: "United Kingdom",
    center: { lat: 53.4084, lng: -2.9916 },
    zoom: 13,
    dbName: "Liverpool",
    timezone: "Europe/London",
  },
  "glasgow-uk": {
    slug: "glasgow-uk",
    name: "Glasgow",
    country: "United Kingdom",
    center: { lat: 55.8642, lng: -4.2518 },
    zoom: 13,
    dbName: "Glasgow",
    timezone: "Europe/London",
  },
  "birmingham-uk": {
    slug: "birmingham-uk",
    name: "Birmingham",
    country: "United Kingdom",
    center: { lat: 52.4862, lng: -1.8904 },
    zoom: 13,
    dbName: "Birmingham",
    timezone: "Europe/London",
  },
  "bristol-uk": {
    slug: "bristol-uk",
    name: "Bristol",
    country: "United Kingdom",
    center: { lat: 51.4545, lng: -2.5879 },
    zoom: 13,
    dbName: "Bristol",
    timezone: "Europe/London",
  },
  "brighton-uk": {
    slug: "brighton-uk",
    name: "Brighton",
    country: "United Kingdom",
    center: { lat: 50.8225, lng: -0.1372 },
    zoom: 13,
    dbName: "Brighton",
    timezone: "Europe/London",
  },
  "leeds-uk": {
    slug: "leeds-uk",
    name: "Leeds",
    country: "United Kingdom",
    center: { lat: 53.8008, lng: -1.5491 },
    zoom: 13,
    dbName: "Leeds",
    timezone: "Europe/London",
  },
  "edinburgh-uk": {
    slug: "edinburgh-uk",
    name: "Edinburgh",
    country: "United Kingdom",
    center: { lat: 55.9533, lng: -3.1883 },
    zoom: 13,
    dbName: "Edinburgh",
    timezone: "Europe/London",
  },
  "cardiff-uk": {
    slug: "cardiff-uk",
    name: "Cardiff",
    country: "United Kingdom",
    center: { lat: 51.4816, lng: -3.1791 },
    zoom: 13,
    dbName: "Cardiff",
    timezone: "Europe/London",
  },
  "belfast-uk": {
    slug: "belfast-uk",
    name: "Belfast",
    country: "United Kingdom",
    center: { lat: 54.5973, lng: -5.9301 },
    zoom: 13,
    dbName: "Belfast",
    timezone: "Europe/London",
  },

  // --- Ireland ---
  "dublin-ie": {
    slug: "dublin-ie",
    name: "Dublin",
    country: "Ireland",
    center: { lat: 53.3498, lng: -6.2603 },
    zoom: 13,
    dbName: "Dublin",
    timezone: "Europe/Dublin",
  },
  "galway-ie": {
    slug: "galway-ie",
    name: "Galway",
    country: "Ireland",
    center: { lat: 53.2707, lng: -9.0568 },
    zoom: 14,
    dbName: "Galway",
    timezone: "Europe/Dublin",
  },
  "cork-ie": {
    slug: "cork-ie",
    name: "Cork",
    country: "Ireland",
    center: { lat: 51.8985, lng: -8.4756 },
    zoom: 13,
    dbName: "Cork",
    timezone: "Europe/Dublin",
  },

  // --- Canada ---
  "toronto-on": {
    slug: "toronto-on",
    name: "Toronto",
    country: "Canada",
    center: { lat: 43.6532, lng: -79.3832 },
    zoom: 12,
    dbName: "Toronto",
    timezone: "America/Toronto",
  },
  "montreal-qc": {
    slug: "montreal-qc",
    name: "Montreal",
    country: "Canada",
    center: { lat: 45.5017, lng: -73.5673 },
    zoom: 12,
    dbName: "Montreal",
    timezone: "America/Toronto",
  },
  "vancouver-bc": {
    slug: "vancouver-bc",
    name: "Vancouver",
    country: "Canada",
    center: { lat: 49.2827, lng: -123.1207 },
    zoom: 12,
    dbName: "Vancouver",
    timezone: "America/Vancouver",
  },
  "calgary-ab": {
    slug: "calgary-ab",
    name: "Calgary",
    country: "Canada",
    center: { lat: 51.0447, lng: -114.0719 },
    zoom: 12,
    dbName: "Calgary",
    timezone: "America/Edmonton",
  },
  "halifax-ns": {
    slug: "halifax-ns",
    name: "Halifax",
    country: "Canada",
    center: { lat: 44.6488, lng: -63.5752 },
    zoom: 13,
    dbName: "Halifax",
    timezone: "America/Halifax",
  },

  // --- Australia ---
  "melbourne-au": {
    slug: "melbourne-au",
    name: "Melbourne",
    country: "Australia",
    center: { lat: -37.8136, lng: 144.9631 },
    zoom: 12,
    dbName: "Melbourne",
    timezone: "Australia/Melbourne",
  },
  "sydney-au": {
    slug: "sydney-au",
    name: "Sydney",
    country: "Australia",
    center: { lat: -33.8688, lng: 151.2093 },
    zoom: 12,
    dbName: "Sydney",
    timezone: "Australia/Sydney",
  },
  "brisbane-au": {
    slug: "brisbane-au",
    name: "Brisbane",
    country: "Australia",
    center: { lat: -27.4698, lng: 153.0251 },
    zoom: 12,
    dbName: "Brisbane",
    timezone: "Australia/Brisbane",
  },
  "perth-au": {
    slug: "perth-au",
    name: "Perth",
    country: "Australia",
    center: { lat: -31.9505, lng: 115.8605 },
    zoom: 12,
    dbName: "Perth",
    timezone: "Australia/Perth",
  },
  "adelaide-au": {
    slug: "adelaide-au",
    name: "Adelaide",
    country: "Australia",
    center: { lat: -34.9285, lng: 138.6007 },
    zoom: 12,
    dbName: "Adelaide",
    timezone: "Australia/Adelaide",
  },

  // --- South Africa ---
  "johannesburg-za": {
    slug: "johannesburg-za",
    name: "Johannesburg",
    country: "South Africa",
    center: { lat: -26.2041, lng: 28.0473 },
    zoom: 12,
    dbName: "Johannesburg",
    timezone: "Africa/Johannesburg",
  },
  "cape-town-za": {
    slug: "cape-town-za",
    name: "Cape Town",
    country: "South Africa",
    center: { lat: -33.9249, lng: 18.4241 },
    zoom: 12,
    dbName: "Cape Town",
    timezone: "Africa/Johannesburg",
  },
  "durban-za": {
    slug: "durban-za",
    name: "Durban",
    country: "South Africa",
    center: { lat: -29.8587, lng: 31.0218 },
    zoom: 12,
    dbName: "Durban",
    timezone: "Africa/Johannesburg",
  },

  // --- Germany ---
  "berlin-de": {
    slug: "berlin-de",
    name: "Berlin",
    country: "Germany",
    center: { lat: 52.5200, lng: 13.4050 },
    zoom: 12,
    dbName: "Berlin",
    timezone: "Europe/Berlin",
  },
  "hamburg-de": {
    slug: "hamburg-de",
    name: "Hamburg",
    country: "Germany",
    center: { lat: 53.5511, lng: 9.9937 },
    zoom: 12,
    dbName: "Hamburg",
    timezone: "Europe/Berlin",
  },
  "munich-de": {
    slug: "munich-de",
    name: "Munich",
    country: "Germany",
    center: { lat: 48.1351, lng: 11.5820 },
    zoom: 12,
    dbName: "Munich",
    timezone: "Europe/Berlin",
  },
  "cologne-de": {
    slug: "cologne-de",
    name: "Cologne",
    country: "Germany",
    center: { lat: 50.9375, lng: 6.9603 },
    zoom: 13,
    dbName: "Cologne",
    timezone: "Europe/Berlin",
  },
  "frankfurt-de": {
    slug: "frankfurt-de",
    name: "Frankfurt",
    country: "Germany",
    center: { lat: 50.1109, lng: 8.6821 },
    zoom: 13,
    dbName: "Frankfurt am Main",
    timezone: "Europe/Berlin",
  },
  "dusseldorf-de": {
    slug: "dusseldorf-de",
    name: "Düsseldorf",
    country: "Germany",
    center: { lat: 51.2277, lng: 6.7735 },
    zoom: 13,
    dbName: "Düsseldorf",
    timezone: "Europe/Berlin",
  },
  "leipzig-de": {
    slug: "leipzig-de",
    name: "Leipzig",
    country: "Germany",
    center: { lat: 51.3397, lng: 12.3731 },
    zoom: 13,
    dbName: "Leipzig",
    timezone: "Europe/Berlin",
  },
  "stuttgart-de": {
    slug: "stuttgart-de",
    name: "Stuttgart",
    country: "Germany",
    center: { lat: 48.7758, lng: 9.1829 },
    zoom: 13,
    dbName: "Stuttgart",
    timezone: "Europe/Berlin",
  },

  // --- Switzerland ---
  "zurich-ch": {
    slug: "zurich-ch",
    name: "Zürich",
    country: "Switzerland",
    center: { lat: 47.3769, lng: 8.5417 },
    zoom: 13,
    dbName: "Zürich",
    timezone: "Europe/Zurich",
  },
  "basel-ch": {
    slug: "basel-ch",
    name: "Basel",
    country: "Switzerland",
    center: { lat: 47.5596, lng: 7.5886 },
    zoom: 13,
    dbName: "Basel",
    timezone: "Europe/Zurich",
  },
  "bern-ch": {
    slug: "bern-ch",
    name: "Bern",
    country: "Switzerland",
    center: { lat: 46.9480, lng: 7.4474 },
    zoom: 13,
    dbName: "Bern",
    timezone: "Europe/Zurich",
  },
  "luzern-ch": {
    slug: "luzern-ch",
    name: "Luzern",
    country: "Switzerland",
    center: { lat: 47.0502, lng: 8.3093 },
    zoom: 13,
    dbName: "Luzern",
    timezone: "Europe/Zurich",
  },
};

/**
 * Cities exposed by the current product. The full CITIES registry remains the
 * canonical legacy/pipeline catalog so old data and manual tools keep working.
 */
export const PUBLIC_CITY_SLUGS = ["boston-ma", "new-york-ny", "los-angeles-ca"] as const;
export type PublicCitySlug = (typeof PUBLIC_CITY_SLUGS)[number];
export const PRIMARY_CITY_SLUG: PublicCitySlug = "boston-ma";
export const PUBLIC_CITIES: Record<PublicCitySlug, CityConfig> = {
  "boston-ma": CITIES["boston-ma"],
  "new-york-ny": CITIES["new-york-ny"],
  "los-angeles-ca": CITIES["los-angeles-ca"],
};

export function isPublicCitySlug(value: string): value is PublicCitySlug {
  return PUBLIC_CITY_SLUGS.includes(value as PublicCitySlug);
}

export function getCitySlugForVenueCity(venueCity: string): string | undefined {
  const normalized = venueCity.trim().toLowerCase();
  return Object.values(CITIES).find(
    (c) => c.dbName.toLowerCase() === normalized
  )?.slug;
}

export function getCityConfigForVenueCity(venueCity: string): CityConfig | undefined {
  const normalized = venueCity.trim().toLowerCase();
  return Object.values(CITIES).find(
    (c) => c.dbName.toLowerCase() === normalized
  );
}

export const DATE_RANGES = [
  { labelKey: "allDates", value: "all" },
  { labelKey: "today", value: "today" },
  { labelKey: "thisWeekend", value: "weekend" },
  { labelKey: "thisWeek", value: "week" },
  { labelKey: "thisMonth", value: "month" },
  { labelKey: "pickDates", value: "custom" },
] as const;

export type DateRangeValue = (typeof DATE_RANGES)[number]["value"];

// --- Nearby cities ---

export interface NearbyCityInfo {
  slug: string;
  name: string;
  distanceKm: number;
}

/** Haversine distance in km between two lat/lng points. */
export function haversineKm(
  lat1: number,
  lng1: number,
  lat2: number,
  lng2: number
): number {
  const R = 6371;
  const dLat = ((lat2 - lat1) * Math.PI) / 180;
  const dLng = ((lng2 - lng1) * Math.PI) / 180;
  const a =
    Math.sin(dLat / 2) ** 2 +
    Math.cos((lat1 * Math.PI) / 180) *
      Math.cos((lat2 * Math.PI) / 180) *
      Math.sin(dLng / 2) ** 2;
  return R * 2 * Math.atan2(Math.sqrt(a), Math.sqrt(1 - a));
}

/**
 * Return cities in the same country within `maxKm` of the given city,
 * sorted by distance. Returns empty array for isolated cities.
 */
export function getNearbyCities(
  citySlug: string,
  maxKm = 200
): NearbyCityInfo[] {
  const origin = CITIES[citySlug];
  if (!origin) return [];

  const results: NearbyCityInfo[] = [];
  for (const c of Object.values(PUBLIC_CITIES)) {
    if (c.slug === citySlug) continue;
    if (c.country !== origin.country) continue;
    const d = haversineKm(
      origin.center.lat,
      origin.center.lng,
      c.center.lat,
      c.center.lng
    );
    if (d <= maxKm) {
      results.push({ slug: c.slug, name: c.name, distanceKm: Math.round(d) });
    }
  }
  return results.sort((a, b) => a.distanceKm - b.distanceKm);
}
